import { paths } from '../../routes/constants';

export const dataTypePathMap = {
  1: paths.INVENTORY_CATALOGUE_LISTING,
  2: paths.FULFILLMENT_ORDERS,
  3: paths.INVENTORY_PRODUCTS,
  4: paths.B2B_ORDER_DETAILS,
  5: paths.ADVANCE_SHIPPING_NOTES_LISTING,
};

export const SEARCH_TEXT = 'Search Catalogue Products, Inventory Products, B2B Orders, Orders and ASNs...';

export const SEARCH_TEXT_PLACEHOLDER = 'Search products, orders, and ASNs...';

export const COLORS = {
  SELECTED_BG_COLOR: '#e7e7e7',
};

export const TITLES_MAP = {
  ORDER: 'Orders',
  ASN: 'Inbounds',
  B2B_ORDERS: 'B2B Orders',
  CATALOGUE_PRODUCT: 'Catalog',
  INVENTORY_PRODUCT: 'Inventory',
};
